import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, take } from 'rxjs';
import { APIResponse } from 'fakturnia-shared';
import { ApiService } from 'shared/services/api.service';
import { Utils } from 'fakturnia-shared';
import { settings } from 'environments/environment';

@Component({
  selector: 'app-remote-login',
  templateUrl: './remote-login.component.html',
  styleUrls: ['./remote-login.component.scss']
})
export class RemoteLoginComponent implements OnDestroy {

  public readonly ACCESS_TOKEN = settings.accessTokenKey;
  public readonly SESSION_ID = settings.sessionIdKey;
  public readonly REFRESH_TOKEN = settings.refreshTokenKey;
  
  private _subscriptions:Subscription[] = []
  constructor(
    private _route:ActivatedRoute,
    private _router:Router,
    private _apiService:ApiService
    ) {
    this._subscriptions.push(this._route.params.subscribe(
      (data:any)=> {
        if(data != null)
        {
          if(Utils.isNullOrEmpty(data.oneTimeToken))
          {
            console.log("invalid_token")
            this._router.navigateByUrl('/')
          }

          const oneTimeToken = data.oneTimeToken

          this._login(oneTimeToken)
        }
      }
    ))
  }

  private _login(oneTimeToken) {


    this._apiService.getOneTimeToken(oneTimeToken)
    .pipe(take(1)).subscribe({
      next: (response:APIResponse) => {
        if(response.success) {

          localStorage.setItem(this.ACCESS_TOKEN, response.data.accessToken);
          localStorage.setItem(this.REFRESH_TOKEN, response.data.refreshToken);
          localStorage.setItem(this.SESSION_ID, response.data.sessionId);
          location.href = ""
          location.reload()
        }
      }
    })
    
  }

  ngOnDestroy(): void {
    this._subscriptions.forEach(sub=>sub.unsubscribe())
  }
}
